import { ref } from 'vue';
import { segmentsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';

export const useSegmentsGroupsCount = createGlobalState(() => {
    const teamId = Spark.state.currentTeam.id;

    // [segmentId]: groupsCount
    // undefined = loading
    // null = not found
    const groupCounts = ref({});

    const fetching = ref(false);

    /**
     * @param {number[]} segmentIds
     */
    const fetchSegmentsGroupsCount = async (segmentIds) => {
        // remove existing ids to avoid computing them again
        segmentIds = segmentIds.filter((segmentId) => !groupCounts.value[segmentId]);

        if (!segmentIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchSegmentsGroupsCount(segmentIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            const response = await segmentsClient.getSegmentsGroupCounts(
                { teamId },
                {
                    segment_ids: segmentIds,
                }
            );

            segmentIds.forEach((segmentId) => {
                groupCounts.value[segmentId] = response.data.counts[segmentId] ?? 0;
            });
        } finally {
            fetching.value = false;
        }
    };

    return {
        fetchSegmentsGroupsCount,
        groupCounts,
    };
});
